export default __webpack_public_path__ + "static/media/banner-transbrasil-mobile3.fc2e0053.png";